import { render, staticRenderFns } from "./SgarhNumberOverviewPage.vue?vue&type=template&id=04889f8c&scoped=true&"
import script from "./SgarhNumberOverviewPage.vue?vue&type=script&lang=js&"
export * from "./SgarhNumberOverviewPage.vue?vue&type=script&lang=js&"
import style0 from "./SgarhNumberOverviewPage.vue?vue&type=style&index=0&id=04889f8c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04889f8c",
  null
  
)

export default component.exports